import { Plus, Download } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { Button } from "@/components/ui/button";

export default function Billing() {
  const usage = [40, 55, 60, 48, 72, 80, 65, 90, 85, 92, 88, 95];
  return (
    <div className="space-y-6">
      <PageHeader
        title="Billing & usage"
        description="Account balance, message volume and invoice history."
        actions={<Button size="sm"><Plus className="h-4 w-4" />Top up balance</Button>}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="rounded-lg border border-border bg-card p-5">
          <div className="text-xs uppercase tracking-wide text-muted-foreground">Current balance</div>
          <div className="mt-2 text-3xl font-semibold">$1,284.50</div>
          <div className="text-xs text-muted-foreground">USD - auto top-up off</div>
        </div>
        <div className="rounded-lg border border-border bg-card p-5">
          <div className="text-xs uppercase tracking-wide text-muted-foreground">This month</div>
          <div className="mt-2 text-3xl font-semibold">$612.40</div>
          <div className="text-xs text-success">+8.2% vs last month</div>
        </div>
        <div className="rounded-lg border border-border bg-card p-5">
          <div className="text-xs uppercase tracking-wide text-muted-foreground">MAU</div>
          <div className="mt-2 text-3xl font-semibold">8,412 <span className="text-base font-normal text-muted-foreground">/ 10K</span></div>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-muted">
            <div className="h-full rounded-full bg-primary" style={{ width: "84%" }} />
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-border bg-card p-5">
        <div className="flex items-center justify-between">
          <h2 className="text-sm font-semibold">Usage trend</h2>
          <span className="text-xs text-muted-foreground">Messages - last 12 months</span>
        </div>
        <div className="mt-4 flex h-44 items-end gap-2">
          {usage.map((v, i) => (
            <div key={i} className="flex flex-1 flex-col items-center gap-1">
              <div className="w-full rounded-t bg-primary/80 transition-colors hover:bg-primary" style={{ height: `${v}%` }} />
              <span className="text-[10px] text-muted-foreground">{["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][i]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-border bg-card">
        <div className="flex items-center justify-between border-b border-border px-5 py-4">
          <h2 className="text-sm font-semibold">Billing history</h2>
          <Button variant="outline" size="sm"><Download className="h-4 w-4" />Download all</Button>
        </div>
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="px-5 py-3 text-left font-medium">Date</th>
              <th className="px-5 py-3 text-left font-medium">Description</th>
              <th className="px-5 py-3 text-right font-medium">Amount</th>
              <th className="px-5 py-3 text-right font-medium">Balance after</th>
              <th className="w-10" />
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {[
              { d: "Nov 22, 2026", desc: "Top-up via Visa 4242", amt: 500.0, bal: 1284.5 },
              { d: "Nov 20, 2026", desc: "Marketing conversations (1,420)", amt: -126.4, bal: 784.5 },
              { d: "Nov 15, 2026", desc: "Utility conversations (3,210)", amt: -64.2, bal: 910.9 },
              { d: "Nov 01, 2026", desc: "Monthly platform fee -- Growth", amt: -99.0, bal: 975.1 },
              { d: "Oct 30, 2026", desc: "Top-up via Visa 4242", amt: 1000.0, bal: 1074.1 },
            ].map((row) => (
              <tr key={row.d + row.desc} className="hover:bg-muted/40">
                <td className="px-5 py-3 text-xs text-muted-foreground">{row.d}</td>
                <td className="px-5 py-3">{row.desc}</td>
                <td className={`px-5 py-3 text-right font-medium ${row.amt < 0 ? "text-foreground" : "text-success"}`}>{row.amt < 0 ? "" : "+"}${Math.abs(row.amt).toFixed(2)}</td>
                <td className="px-5 py-3 text-right text-muted-foreground">${row.bal.toFixed(2)}</td>
                <td className="px-2 py-3"><Button variant="ghost" size="sm">Receipt</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
